import { LOG_OUT } from '../../sharedTypes';

export const logOut = () => ({
  type: LOG_OUT,
});
